import { Usuario, Funcionalidad, LogSession } from './index';

export class LogActividad {
    //PK
    logActividadId : number;

    //Atributos
    fechaHoraInicio : Date;
    fechaHoraFin : Date;

    //Relaciones
    usuario : Usuario;
    funcionalidad : Funcionalidad;
    logSession : LogSession;

    //Constructor
    constructor(){};

    //Metodos
    clone(): any {
        var cloneObj = new (this.constructor());
        for (var attribut in this) {
            if (typeof this[attribut] === "object") {
                cloneObj[attribut] = this.clone();
            } else {
                cloneObj[attribut] = this[attribut];
            }
        }
        return cloneObj;
    }

    copiar(objeto : any){
        //Propios
        this.logActividadId = objeto.logActividadId;
        this.fechaHoraInicio = objeto.fechaHoraInicio;
        this.fechaHoraFin = objeto.fechaHoraFin;

        //Relaciones
        if(objeto.usuario != null){
            this.usuario = new Usuario();
            this.usuario.copiar(objeto.usuario);
        }
        if(objeto.funcionalidad != null){
            this.funcionalidad = new Funcionalidad();
            this.funcionalidad.copiar(objeto.funcionalidad);
        }
        if(objeto.logSession != null){
            this.logSession = new LogSession();
            this.logSession.copiar(objeto.logSession);
        }
    }
}

